function getFullname(value) {
  let prefix
  if (!value.positionID) {    
    prefix = (value.prefixName !== 'NULL' ? value.prefixName : '')
  } else if (value.titleName2 && value.titleName3) {
    prefix = (value.titleName2 !== 'NULL' ? value.titleName2 : "") + (value.titleName3 !== 'NULL' ? value.titleName3 : "")
  } else if (value.titleName2) {    
    prefix = (value.titleName2 !== 'NULL' ? value.titleName2 : '')
  } else if (value.titleName3) {            
    prefix = (value.titleName3 !== 'NULL' ? value.titleName3 : '')
  } else {    
    prefix = (value.prefixName !== 'NULL' ? value.prefixName : '')
  }
  return prefix + " " + value.firstName + " " + value.surName
}

function getFullnameEN(value)
{
  
  return value.firstNameEN + " " + value.surNameEN
}

function getImage(value) {   
  return 'https://apis.eng.psu.ac.th/personnel/v1/photo/' + value.uniStaffID + '.jpg'
  /*let imageSource = null
  if (value.positionID === 1) {
    imageSource = 'https://uiux.eng.psu.ac.th/storage/intaniabuddy/teacher/' + value.uniStaffID + '.jpg';
  } else {
    imageSource = 'https://phoenix.eng.psu.ac.th/absence/timestamp/images/' + value.uniStaffID + '.jpg';
  }

  return imageSource*/
}

function personMapping(data={}, index) {  
    let rowData = {
    key: index,    
    staffID : data.STAFF_ID ? data.STAFF_ID : null,
    uniStaffID: data.UNI_STAFF_ID ? data.UNI_STAFF_ID : null,    
    prefixCall: data.PREFIX ? data.PREFIX : null,
    prefixName: data.P_NAME_TH ? data.P_NAME_TH : null,
    firstName: data.FNAME_TH ? data.FNAME_TH : null,
    surName: data.SNAME_TH ? data.SNAME_TH : null,   
    firstNameEN: data.FNAME_ENG ? data.FNAME_ENG : null,
    surNameEN: data.SNAME_ENG ? data.SNAME_ENG : null, 
    deptName: data.DEPT_NAME_TH ? data.DEPT_NAME_TH : null,
    officeTel: data.OFFICE_TEL ? data.OFFICE_TEL : null,
    email: data.EMAIL ? data.EMAIL : null,
    website: data.WEBSITE ? data.WEBSITE : null,
    facebook: data.FACEBOOK ? data.FACEBOOK : null,
    twitter: data.TWITTER ? data.TWITTER : null,
    positionID: data.POSITION_ID ? data.POSITION_ID : null,
    positionname: data.POSITION_NAME ? data.POSITION_NAME : null,
    titleName2: data.TITLE_NAME2 ? data.TITLE_NAME2 : null,
    titleName3: data.TITLE_NAME3 ? data.TITLE_NAME3 : null,
    typeName: data.TYPE_NAME ? data.TYPE_NAME : null,
    image: null,
    fullName: null
  }
  rowData.image = rowData.uniStaffID ? getImage(rowData) : null
  rowData.fullName = rowData.uniStaffID ? getFullname(rowData) : null
  rowData.fullNameEN = rowData.uniStaffID ? getFullnameEN(rowData) : null

  return rowData
}

export {
  personMapping
}